// react
import { createContext, Dispatch, SetStateAction, useContext, useState } from 'react'

// external libs
import { Box } from '@material-ui/core'

// components
import ChecklistItem from './ChecklistItem'

// types
import type { Checklist } from '../../../services/um/useChecklist'

export interface ChecklistListProps {
    topicID: number
    checklistList: Checklist[]
    onChange?: () => void
}

function ChecklistList(props: ChecklistListProps) {
    const { topicID, checklistList, onChange } = props

    const [editingChecklistId, setEditingChecklistId] = useState<number | string | null>(null)

    return (
        <ChecklistContext.Provider
            value={{
                hasEditingChecklist: !!editingChecklistId,
                setEditingChecklistId,
            }}
        >
            <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
                {checklistList?.map((checklist) => (
                    <ChecklistItem
                        key={checklist.checklistID}
                        topicID={topicID}
                        checklist={checklist}
                        onChange={onChange}
                    />
                ))}
            </Box>
        </ChecklistContext.Provider>
    )
}

export interface ChecklistContextType {
    hasEditingChecklist: boolean
    setEditingChecklistId: Dispatch<SetStateAction<number | string | null>>
}

const ChecklistContext = createContext<ChecklistContextType | undefined>(undefined)

export const useChecklistContext = () => {
    const ctx = useContext(ChecklistContext)
    if (!ctx) {
        throw new Error('useChecklistContext must be used within a ChecklistList component')
    }
    return ctx
}

export default ChecklistList
